import { render, staticRenderFns } from "./SubmitTwoFactorCode.vue?vue&type=template&id=4467c971&scoped=true"
import script from "./SubmitTwoFactorCode.vue?vue&type=script&lang=ts"
export * from "./SubmitTwoFactorCode.vue?vue&type=script&lang=ts"
import style0 from "./SubmitTwoFactorCode.vue?vue&type=style&index=0&id=4467c971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467c971",
  null
  
)

export default component.exports